import type {
  ConfigFormat,
  McpAuthType,
  McpClientId,
} from "@arcadeai/ui-kit/mcp-gateway-connect";
import { usePostHog } from "posthog-js/react";
import { useCallback } from "react";

type ConnectTelemetry = {
  onConfigCopy: (
    clientId: McpClientId,
    format: ConfigFormat,
    authType: McpAuthType
  ) => void;
  onDeepLinkClick: (clientId: McpClientId, gatewaySlug: string) => void;
};

export function useMcpGatewayConnectTelemetry(): ConnectTelemetry {
  const posthog = usePostHog();

  const onConfigCopy = useCallback(
    (clientId: McpClientId, format: ConfigFormat, authType: McpAuthType) => {
      posthog?.capture("MCP gateway config copied", {
        client_id: clientId,
        config_format: format,
        auth_type: authType,
      });
    },
    [posthog]
  );

  const onDeepLinkClick = useCallback(
    (clientId: McpClientId, gatewaySlug: string) => {
      posthog?.capture("MCP gateway deep link click", {
        client_id: clientId,
        gateway_slug: gatewaySlug,
      });
    },
    [posthog]
  );

  return { onConfigCopy, onDeepLinkClick };
}
